import { useLocation } from "@tanstack/react-router";

import type { PortalPrefix } from "@/lib/portal-nav";

/**
 * First path segment under the portal prefix, e.g. "registrations" for /operator/registrations.
 * Treats the bare prefix as "overview" (for redirects that land on /government/ only).
 */
export function usePortalSection(portalPrefix: PortalPrefix): string {
  const { pathname } = useLocation();
  if (pathname === portalPrefix || pathname === `${portalPrefix}/`) {
    return "overview";
  }
  const withoutPrefix = pathname.startsWith(`${portalPrefix}/`)
    ? pathname.slice(portalPrefix.length + 1)
    : pathname;
  return withoutPrefix.split("/")[0] || "overview";
}
